/**
 * Portal page listing the library's digital resources.
 */

import { Link } from "react-router-dom";
import { usePatronAuth } from "../contexts/PatronAuthContext";
import { DigitalResourcesSection } from "../digital";

export function DigitalResourcesPage() {
  const { isAuthenticated } = usePatronAuth();

  return (
    <div className="space-y-8">
      <header className="max-w-2xl">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Ressources numériques</h1>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          Presse, cours, soutien scolaire, livres numériques et films en ligne, inclus dans votre
          abonnement. Cliquez sur un service : il s&apos;ouvre dans un nouvel onglet et vous y êtes
          directement connecté.
        </p>
        {!isAuthenticated && (
          <p className="mt-3 text-sm text-gray-600 dark:text-gray-400">
            <Link
              to="/opac/login"
              state={{ from: "/opac/ressources-numeriques" }}
              className="font-medium text-blue-600 hover:underline dark:text-blue-400"
            >
              Connectez-vous
            </Link>{" "}
            avec votre carte de bibliothèque pour y accéder.
          </p>
        )}
      </header>

      <DigitalResourcesSection variant="page" />
    </div>
  );
}

export default DigitalResourcesPage;
